import React, { useState, useEffect } from "react";
import SchedulingWrapper from "./components/index.style";
import Spacer from "../../components/layouts/Spacer";
import { Views } from "react-big-calendar";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  convertSchedulingEventsToCalender,
  convertSchedulingEventsFromCalender,
} from "../../components/util/helpers";
import moment from "moment";
import Calendar from "./components/Calendar";
import ApprovalModal from "./components/ApprovalModal";
import SchedulingHeader from "./components/SchedulingHeader";
import EventModal from "./components/EventModal";
import {
  loadPage,
  editSchedulingEvent,
  changeClientTariff,
  deleteSchedulingEvent,
  createSchedulingEvent,
  reset,
} from "./schedulingSlice";
import CustomEvent from "./components/CustomEvent";
import { listHolidays } from "../../api/server";

const Scheduling = (props) => {
  const {
    fullScreen,
    initialYear,
    initialMonth,
    showPatientDetails,
    fullScreenModal,
    activeTab,
    nonActive,
  } = props;
  const location = useLocation();
  const [currentDate, setCurrentDate] = useState(null);
  const [calenderView, setCalenderView] = useState(Views.MONTH);
  const [events, setEvents] = useState([]);
  const [visible, setVisible] = useState(false);
  const [activeEvent, setActiveEvent] = useState(null);
  const [mode, setMode] = useState(null);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [approvalModalVisible, setApprovalModalVisible] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [originalActiveEvent, setOriginalActiveEvent] = useState(null);

  const patientId = useSelector(
    (state) => state.patientDetails.activePatient.id
  );
  const branchId = useSelector(
    (state) => state.patientDetails.activePatient.branch
  );

  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );

  const loadLoading = useSelector(
    (state) => state.pendingActions["scheduling/load"]
  );

  const createLoading = useSelector(
    (state) => state.pendingActions["scheduling/create"]
  );
  const editLoading = useSelector(
    (state) => state.pendingActions["scheduling/edit"]
  );
  const deleteLoading = useSelector(
    (state) => state.pendingActions["scheduling/delete"]
  );
  const loading = loadLoading || createLoading || editLoading || deleteLoading;

  const { page: schedulingPage } = useSelector((state) => state.scheduling);
  const { items, effective_orders, order_time_extractions } = schedulingPage;

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      location.state &&
      location.state.activeTab &&
      location.state.activeTab === "scheduling"
    ) {
      const date = moment().set("year", location.state.year);
      date.set("month", location.state.month - 1).startOf("month");
      setCurrentDate(date);
    }
  }, [location.state]);

  useEffect(() => {
    if (initialYear && initialMonth) {
      setCurrentDate(
        moment().set({ year: initialYear, month: initialMonth - 1 })
      );
    } else if (!location.state || (location.state && !location.state.month)) {
      setCurrentDate(moment());
    }
  }, [initialYear, initialMonth]);

  useEffect(() => {
    const currentMonth = currentDate && moment(currentDate).month();
    const currentYear = currentDate && moment(currentDate).year();
    let startMonth = moment([currentYear, currentMonth, 1]).startOf("month");
    let endDate = startMonth.clone().endOf("month");
    if (
      patientId &&
      currentDate &&
      (!activeTab || activeTab === "scheduling")
    ) {
      dispatch(
        loadPage({
          query: {
            from: moment.utc(startMonth).format(),
            to: moment.utc(endDate).format(),
          },
        })
      );
    }
  }, [dispatch, currentDate, patientId, activeTab]);

  useEffect(() => {
    return function cleanup() {
      dispatch(reset());
    };
  }, []);

  useEffect(() => {
    const convertedToCalender = convertSchedulingEventsToCalender(items);
    setEvents(convertedToCalender);
    setActiveEvent(null);
  }, [items]);

  useEffect(() => {
    if (currentDate) {
      let filter = {
        $and: [
          {
            date: {
              $gte: moment(currentDate).startOf("month").format(),
            },
          },
          {
            date: {
              $lte: moment(currentDate).endOf("month").format(),
            },
          },
        ],
      };

      listHolidays({ filter }).then(({ error, data }) => {
        if (data) {
          setHolidays(data.items);
        }
      });
    }
    setFilteredOrders([]);
  }, [currentDate]);

  const onHideApprovalModal = () => {
    setApprovalModalVisible(false);
  };

  const onlaunchApprovalModal = () => {
    setApprovalModalVisible(true);
  };

  const onNextMonth = () => {
    setCurrentDate(
      moment(currentDate).add(1, "months").startOf("month").format()
    );
  };
  const onPreviousMonth = () => {
    setCurrentDate(
      moment(currentDate).subtract(1, "months").startOf("month").format()
    );
  };

  const onNextDate = () => {
    if (calenderView === Views.MONTH) {
      setCurrentDate(
        moment(currentDate).add(1, "months").startOf("month").format()
      );
    } else if (calenderView === Views.WEEK) {
      const fromMonth = moment(currentDate).startOf("week").get("month");
      const toMonth = moment(currentDate)
        .add(7, "days")
        .startOf("week")
        .get("month");
      if (fromMonth < toMonth) {
        setCurrentDate(
          moment(currentDate).add(7, "days").endOf("week").format()
        );
      } else {
        setCurrentDate(
          moment(currentDate).add(7, "days").startOf("week").format()
        );
      }
    } else if (calenderView === Views.DAY) {
      setCurrentDate(moment(currentDate).add(1, "days").format());
    }
  };
  const onPreviousDate = () => {
    if (calenderView === Views.MONTH) {
      setCurrentDate(
        moment(currentDate).subtract(1, "months").startOf("month").format()
      );
    } else if (calenderView === Views.WEEK) {
      const fromMonth = moment(currentDate).endOf("week").get("month");
      const toMonth = moment(currentDate)
        .subtract(7, "days")
        .endOf("week")
        .get("month");
      if (fromMonth > toMonth) {
        setCurrentDate(
          moment(currentDate).subtract(7, "days").startOf("week").format()
        );
      } else {
        setCurrentDate(
          moment(currentDate).subtract(7, "days").endOf("week").format()
        );
      }
    } else if (calenderView === Views.DAY) {
      setCurrentDate(moment(currentDate).subtract(1, "days").format());
    }
  };

  const onNavigate = (val) => {
    setCurrentDate(moment(val).format());
    setCalenderView(Views.DAY);
  };

  const onCalenderViewChanged = (val) => {
    setCalenderView(val);
  };

  const onChangeView = (e) => {
    setCalenderView(e.target.value);
  };

  const changeEvent = async (changed, start, end) => {
    setActiveEvent({ ...changed, start, end });
    const converted = convertSchedulingEventsFromCalender({
      ...changed,
      start,
      end,
    });
    const params = {
      patientId: patientId,
      branchId: branchId,
      schedulingEvent:
        activeEvent && activeEvent.approved
          ? { id: converted.id, client_tariff_id: converted.client_tariff_id }
          : { deleted: converted.deleted, new: { ...converted } },
    };
    await dispatch(
      activeEvent && activeEvent.approved
        ? changeClientTariff(params)
        : editSchedulingEvent(params)
    );
    setVisible(false);
    reload();
  };

  const createEvent = (newEvent) => {
    setActiveEvent(newEvent);
    setMode("new");
    setVisible(true);
  };

  const editEvent = (newEvent) => {
    setActiveEvent(newEvent);
    setOriginalActiveEvent(newEvent);
    setMode("edit");
    setVisible(true);
  };

  const viewEvent = (newEvent) => {
    setActiveEvent(newEvent);
    setMode("view");
    setVisible(true);
  };

  const goToDayView = (newEvent) => {
    setCurrentDate(moment(newEvent.slots[0]).format());
    setCalenderView(Views.DAY);
  };

  const handleCancel = (e) => {
    setVisible(false);
    setActiveEvent(null);
  };

  const submitEvent = async (e) => {
    const converted = convertSchedulingEventsFromCalender(activeEvent);
    const params = {
      patientId: patientId,
      branchId: branchId,
      schedulingEvent: { deleted: converted.deleted, new: { ...converted } },
    };
    await dispatch(
      mode === "new"
        ? createSchedulingEvent(params)
        : editSchedulingEvent(params)
    );
    reload();
    setVisible(false);
  };

  const removeEvent = async (e) => {
    setVisible(false);
    const params = {
      patientId: patientId,
      branchId: branchId,
      schedulingEvent: { deleted: activeEvent ? activeEvent.id : null },
    };

    await dispatch(deleteSchedulingEvent(params));
    reload();
  };

  const changeActiveEvent = (newEvent) => {
    setActiveEvent(newEvent);
  };

  const onChosenEmployee = (employee) => {
    const client_salary_tariff_id =
      activeEvent?.order?.client?.salary_tariff_id;
    setActiveEvent({
      ...activeEvent,
      employee: employee,
      employee_id: employee.id,
      tariff_id: client_salary_tariff_id || employee.tariff_id,
      oncall: false,
      use_employee_tariff:
        client_salary_tariff_id || employee?.tariff ? true : false,
    });
  };

  const onRemoveEmployee = () => {
    setActiveEvent({
      ...activeEvent,
      employee: null,
      tariff_id: null,
      employee_id: null,
    });
  };

  const onTariffChanged = (val) => {
    setActiveEvent({
      ...activeEvent,
      tariff_id: val,
    });
  };
  const onUseEmployeeTariffChanged = (val) => {
    const clientTariffId = activeEvent?.order?.client?.salary_tariff_id;
    setActiveEvent({
      ...activeEvent,
      use_employee_tariff: val,
      tariff_id: clientTariffId || activeEvent?.employee?.tariff?.id,
    });
  };

  const onTransportationChanged = (val) => {
    setActiveEvent({
      ...activeEvent,
      transportation_cost: val,
    });
  };

  const onOncallChange = (val) => {
    setActiveEvent({
      ...activeEvent,
      oncall: val,
    });
  };

  const reload = async () => {
    const startDate = moment(currentDate).startOf("month");
    var endDate = moment(currentDate).endOf("month");
    if (patientId) {
      await dispatch(
        loadPage({
          query: {
            from: moment.utc(startDate).format(),
            to: moment.utc(endDate).format(),
          },
        })
      );
    }
  };

  const onFilterOrdersChanged = (eventId, val) => {
    const newFiltered = val
      ? filteredOrders.filter((item) => item !== eventId)
      : [...filteredOrders, eventId];
    setFilteredOrders(newFiltered);
  };
  const social_security = "ביטוח לאומי";
  const holocast_survivors_fund = "הקרן לנפגעי שואה";
  const ministry_of_defence = "משרד הביטחון";
  const ordersPalette = {
    [social_security]: "#53C31A",
    [holocast_survivors_fund]: "#F99646",
    [ministry_of_defence]: "#6C64FE",
  };

  const ordersBorderPalette = {
    [social_security]: "#C8D7C2",
    [holocast_survivors_fund]: "#F6BD8D",
    [ministry_of_defence]: "#D8D6FC",
  };

  const ordersBgPalette = {
    [social_security]: "#F1FBEE",
    [holocast_survivors_fund]: "#FDEEE0",
    [ministry_of_defence]: "#F2EFFF",
  };
  const calenderEvents = activeEvent
    ? [
        ...events.filter((item) => item.id !== activeEvent.id),
        { ...activeEvent },
      ]
    : events;

  return (
    <SchedulingWrapper className={fullScreen ? "fullscreen" : "surface"}>
      <SchedulingHeader
        calenderView={calenderView}
        currentDate={currentDate ? currentDate : moment()}
        onChangeView={onChangeView}
        effective_orders={effective_orders}
        order_time_extractions={order_time_extractions}
        ordersPalette={ordersPalette}
        onFilterOrdersChanged={onFilterOrdersChanged}
        onNextDate={onNextDate}
        onPreviousDate={onPreviousDate}
        onlaunchApprovalModal={onlaunchApprovalModal}
        showPatientDetails={showPatientDetails}
        fullScreenModal={fullScreenModal}
        events={events}
        filteredOrders={filteredOrders}
      />
      <Spacer vertical={true} />
      <Calendar
        effective_orders={effective_orders}
        filteredOrders={filteredOrders}
        changeEvent={changeEvent}
        createEvent={createEvent}
        editEvent={editEvent}
        viewEvent={viewEvent}
        ordersBorderPalette={ordersBorderPalette}
        ordersBgPalette={ordersBgPalette}
        orders={effective_orders}
        events={calenderEvents}
        currentDate={currentDate ? currentDate : moment()}
        onNavigate={onNavigate}
        onCalenderViewChanged={onCalenderViewChanged}
        calenderView={calenderView}
        activeEvent={activeEvent}
        goToDayView={goToDayView}
        loading={loading}
        holidays={holidays}
        customEvent={(prop) => (
          <CustomEvent
            calenderView={calenderView}
            event={prop.event}
            ordersPalette={ordersPalette}
            eventProps={prop}
          />
        )}
        activePatient={activePatient}
        nonActive={nonActive}
      />
      <ApprovalModal
        onHide={onHideApprovalModal}
        visible={approvalModalVisible}
        currentDate={currentDate}
        onNextMonth={onNextMonth}
        onPreviousMonth={onPreviousMonth}
        holidays={holidays}
        createEvent={createEvent}
        nonActive={nonActive}
      />

      <EventModal
        activeEvent={activeEvent}
        changeActiveEvent={changeActiveEvent}
        orders={effective_orders}
        currentDate={currentDate}
        onChosenEmployee={onChosenEmployee}
        onRemoveEmployee={onRemoveEmployee}
        onTariffChanged={onTariffChanged}
        onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
        onTransportationChanged={onTransportationChanged}
        onOncallChange={onOncallChange}
        visible={visible}
        submitEvent={submitEvent}
        handleCancel={handleCancel}
        removeEvent={removeEvent}
        mode={mode}
        changeEvent={changeEvent}
        editLoading={editLoading}
        originalEmployeeId={
          originalActiveEvent && originalActiveEvent.employee_id
        }
        patient={activePatient}
      />
    </SchedulingWrapper>
  );
};

export default Scheduling;
